import { render, staticRenderFns } from "./ListItemPage.vue?vue&type=template&id=18b28e7d&scoped=true&"
import script from "./ListItemPage.vue?vue&type=script&lang=js&"
export * from "./ListItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ListItemPage.vue?vue&type=style&index=0&id=18b28e7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b28e7d",
  null
  
)

export default component.exports